import {
  SimpleShowLayout,
  Show,
  TextField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Labeled,
} from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { administrationRequests } from "api/administrationApi";
import { SectionTitle } from "features/SectionTitle";

const ShowSpecificRequirements = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли на изисквания за специалности"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>

      <SimpleShowLayout>
        <SectionTitle
          title="Документи"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={2}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Документ">
              <ReferenceArrayField
                source="documentTypeIds"
                reference={administrationRequests.getPreferenceDocumentTypesSelect()}
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowSpecificRequirements;
